import React, {ReactNode} from 'react';
import {Colors} from "@/constants";
import {IntrinsicElementProps} from "@/utils";
import classnames from "classnames";
import classNames from "classnames";

export type TwoToneTextProps = ({
    w1?: ReactNode;
    w2?: ReactNode;
    array?: ReactNode[];
    reverse?: boolean;
} & ({
    w1: ReactNode;
    w2: ReactNode;
} | {
    array: ReactNode[];
})) & IntrinsicElementProps;
export function TwoToneText({w1, w2, array, reverse, className, ...props}: TwoToneTextProps) {
    return <div {...props} className={classnames('two-tone-text', className)}>
        {w1 && <span style={{color: reverse ? Colors.Yellow : 'white'}}>{w1} </span>}
        {w2 && <span style={{color: reverse ? 'white' : Colors.Yellow}}>{w2}</span>}
        {array?.map((e, i) => <span style={{color: (i % 2 == (reverse ? 1 : 0)) ? Colors.Yellow : 'white'}}>{e}</span>)}
    </div>;
}
